import mongoose from 'mongoose'
import { InboxType } from './Inbox'

export type InboxMemberType = {
    _id?: string
    createdAt?: Date

    inbox?: InboxType // New field that will be populated
    userId: string
    role: 'owner' | 'member'

    /** @deprecated Use inbox field instead. */
    // inboxId?: string

}

const schema = new mongoose.Schema({
  userId: { type: mongoose.Schema.Types.ObjectId, ref: 'User', required: true },
  inboxId: { type: mongoose.Schema.Types.ObjectId, ref: 'Inbox', required: false },
  inbox: { type: mongoose.Schema.Types.ObjectId, ref: 'Inbox', required: true },
  role: { type: String, required: true, enum: ['owner', 'member'] }
}, {
  timestamps: true,
  versionKey: false
})

export const InboxMember = mongoose.model<InboxMemberType>('InboxMember', schema)
